import type { ReactNode } from 'react'

import { type ThemeInterface } from '@procurify/ui-theme'
import { rem } from 'polished'
import styled from 'styled-components'

import { AuditLogRecordLabelStyled } from '@webapp/platform/audit-log/components/AuditLogRecordLabel/styles/AuditLogRecordLabelStyled'
import { type AuditLogStatusEnum } from '@webapp/platform/audit-log/entities/enums/AuditLogStatusEnum'

interface IAuditLogRecordStyledProps {
  children?: ReactNode
  status: AuditLogStatusEnum
}

export const getColorByStatus = (props: {
  theme: ThemeInterface
  status: AuditLogStatusEnum
}): { background: string; content: string } => {
  switch (props.status) {
    case 'Approved':
    case 'Purchased':
    case 'Received':
    case 'Paid':
    case 'Closed':
      return {
        background: props.theme.colors.auditLog.positive.background,
        content: props.theme.colors.auditLog.positive.text,
      }
    case 'Removed':
    case 'Denied':
    case 'Deleted':
    case 'Rejected':
    case 'Cancelled':
      return {
        background: props.theme.colors.auditLog.negative.background,
        content: props.theme.colors.auditLog.negative.text,
      }

    case 'Edited':
    case 'Send PO':
    case 'Created':
    case 'Reopened':
    default:
      return {
        background: props.theme.colors.auditLog.info.background,
        content: props.theme.colors.auditLog.info.text,
      }
  }
}

export const AuditLogRecordStyled = styled.li<IAuditLogRecordStyledProps>`
  position: relative;
  list-style: none;
  background-color: ${(props) => props.theme.colors.content.contentBackground};
  border: 1px solid ${(props) => props.theme.colors.content.border};
  border-left: 3px solid ${(props) => getColorByStatus(props).background};
  padding: ${(props) => {
    const { pxToRem } = props.theme.typography
    return `${pxToRem(26)} ${pxToRem(16)} ${pxToRem(16)}`
  }};
  border-radius: ${({ theme }) =>
    theme.box.borderRadius(theme.typography.htmlFontSize)};

  ${AuditLogRecordLabelStyled} {
    position: absolute;
    top: calc(-1 * ${(props) => props.theme.space.small});
    left: ${rem(-3)};
    background-color: ${(props) => getColorByStatus(props).background};
    color: ${(props) => getColorByStatus(props).content};
  }
`
